import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Parent layout route for /virtual-education and its nested children
 * (e.g. /virtual-education/saint-tms-explained).
 *
 * This is a layout-only route: it renders <Outlet /> so nested child
 * pages can mount. The /virtual-education index page body lives in
 * src/routes/virtual-education.index.tsx.
 */
export const Route = createFileRoute("/virtual-education")({
  component: LayoutComponent,
});

function LayoutComponent() {
  return <Outlet />;
}
